function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuHardLocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Menu - Statistics",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4-4h1.2a.43.43 0 0 0 .4-.4v-4.2a.43.43 0 0 0-.4-.4H2.4a.43.43 0 0 0-.4.4v4.2a.43.43 0 0 0 .4.4zm3 0h1.2a.43.43 0 0 0 .4-.4v-7.2a.43.43 0 0 0-.4-.4H5.4a.43.43 0 0 0-.4.4v7.2a.43.43 0 0 0 .4.4zm-9 0h1.2a.43.43 0 0 0 .4-.4v-2.2a.43.43 0 0 0-.4-.4h-1.2a.43.43 0 0 0-.4.4v2.2a.43.43 0 0 0 .4.4zm3 0H.6a.43.43 0 0 0 .4-.4v-6.2a.43.43 0 0 0-.4-.4H-.6a.43.43 0 0 0-.4.4v6.2a.43.43 0 0 0 .4.4zm8.1 2H-6v-9.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V-1a1 1 0 0 0 1 1H7.5A.5.5 0 0 0 8-.5v-1a.5.5 0 0 0-.5-.5z",
    transform: "translate(12 18)",
    style: {
      fill: "#a9b0b3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuHardLocks);
export default __webpack_public_path__ + "static/media/IconMenuHardLocks.60b83650150c4a9b418d99f859201e51.svg";
export { ForwardRef as ReactComponent };